import type { CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";

function insertedItems<T extends { id: string }>(
  current: readonly T[],
  server: readonly T[],
  insertedIds: readonly string[]
): T[] {
  const currentIds = new Set(current.map((item) => item.id));
  const inserted = new Set(insertedIds);
  return server.filter((item) => inserted.has(item.id) && !currentIds.has(item.id));
}

export function mergeWorkflowInsertion({
  current,
  server,
  inserted
}: {
  current: CanvasDocument;
  server: CanvasDocument;
  inserted: {
    nodeIds: readonly string[];
    edgeIds: readonly string[];
    groupIds: readonly string[];
  };
}): CanvasDocument {
  return {
    ...current,
    nodes: [...current.nodes, ...insertedItems(current.nodes, server.nodes, inserted.nodeIds)],
    edges: [...current.edges, ...insertedItems(current.edges, server.edges, inserted.edgeIds)],
    groups: [...current.groups, ...insertedItems(current.groups, server.groups, inserted.groupIds)]
  };
}
